import { PhoneCall, ExternalLink } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { Button } from '@sara/ui/components/button';
import { useOrgSlug } from '../../../auth';

interface CreateInterviewCallingProps {
  candidateName: string;
  interviewInviteId: string;
  onClose: () => void;
}

function CreateInterviewCalling({
  candidateName,
  interviewInviteId,
  onClose,
}: CreateInterviewCallingProps) {
  const orgSlug = useOrgSlug();

  return (
    <div className="space-y-6">
      <div className="flex flex-col items-center gap-3 py-2">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-info-muted ring-1 ring-inset ring-info/20">
          <PhoneCall className="h-5 w-5 text-info" strokeWidth={1.6} />
        </div>
        <div className="text-center">
          <p className="font-display text-lg font-medium text-foreground">
            Calling {candidateName}…
          </p>
          <p className="mt-1 text-sm text-muted-foreground">
            The call is ringing. When {candidateName} picks up, the agent runs the interview and the
            transcript and result appear on this session. A no-answer shows here too, and you can
            call again.
          </p>
        </div>
      </div>

      <div className="flex justify-end gap-2">
        <Button variant="outline" shape="pill" size="sm" onClick={onClose}>
          Close
        </Button>
        <Button asChild variant="tinted" shape="pill" size="sm" className="gap-1.5">
          <Link
            to="/orgs/$orgSlug/sessions/$interviewId"
            params={{ orgSlug, interviewId: interviewInviteId }}
            onClick={onClose}
          >
            View details
            <ExternalLink className="ml-1 h-3.5 w-3.5" strokeWidth={1.6} />
          </Link>
        </Button>
      </div>
    </div>
  );
}

export { CreateInterviewCalling };
